export enum ENTITY {
  ACCOUNTS = "accounts",
  USERS = "users",
}

export enum WorkspaceDefaultCurrency {
  USD = "usd",
  // Add more currency options if needed
}
